import React from "react";
import "./TextBanner.css";
import Fade from 'react-reveal/Fade';
import { Dimensions } from "../../Helper/sitedimension";

const TextBannerUI = () => {
  const { width } = Dimensions.useWindowDimensions();
  return (
    <div className="textBanner">
      {width > 500 ?
        <div className="container-fluid bn-wr">
          <Fade delay={300}>
            <div className="text-center tx-c">
              This dependency has, however, become the source of our greatest
              vulnerability. Malicious actors with access to data often manipulate
              data in a manner that benefit them at the expense of everyone else.
            <br />
              <br />
              The World Economic Forum has classified{" "}
              <span className="r-txt">cyber-attacks</span> and{" "}
              <span className="r-txt">data theft</span>
              amongst the most severe and likely threats to our economy and
              civilisation. Data resiliency has today become an existential quest.
        </div>
          </Fade>
        </div> :
        <div className="container-fluid bn-wrcp">
          <Fade delay={300}>
            <div className="text-center tx-ccp">
              This dependency has, however, become the source of our greatest
              vulnerability. Malicious actors with access to data often manipulate
              data in a manner that benefit them at the expense of everyone else.
          <br />
              <br />
              The World Economic Forum has classified{" "}
              <span className="r-txtcp">cyber-attacks</span> and{" "}
              <span className="r-txtcp">data theft</span>
              amongst the most severe and likely threats to our economy and
              civilisation. Data resiliency has today become an existential quest.
      </div>
          </Fade>
        </div>
      }
    </div>
  );
};

export default TextBannerUI;
